import React from 'react';
import { ShoppingBag } from 'lucide-react';

const CartIcon = ({ className }) => {
    return (
        <ShoppingBag className={className} />
    );
};

export default CartIcon;
